// Local Date objects are used by date pickers. Only their calendar components
// cross the API boundary, encoded as midnight UTC (the same as birthdays).
export const calendarDateToUTC = (value: Date | null | undefined): Date | null | undefined => {
  if (!value) return value;
  return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()));
};

// Reconstruct local midnight from UTC calendar components so locale formatting
// and editing keep the same day in every time zone.
export const calendarDateFromUTC = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  const date = new Date(value);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};
